<template>
  <div class="examineBox myStatementApply">
    <self-back :pageHeaderList="[{ 'name': '结算单盖章审核' }]"></self-back>
    <div class="containter" v-loading='loading'>
      <ul class="topTab clear">
        <li :class="tab == 5 ? 'active' : ''" @click="tab = 5; verify_status = ''">游戏/电商结算单</li>
        <li :class="tab == 6 ? 'active' : ''" @click="tab = 6; verify_status = ''">拼多多结算单</li>
        <li :class="tab == 4 ? 'active' : ''" @click="tab = 4; verify_status = ''">CPA结算单</li>
        <li :class="tab == 2 ? 'active' : ''" @click="tab = 2; verify_status = ''">MCN结算单</li>
      </ul>
      <div style="margin: 0 16px 5px;" class="topSelect flex">
        <template>
          <!-- 人力角色状态筛选 -->
          <div v-if="isHumanDept" class="selectItem">
            <label>审核状态：</label>
            <el-select v-model="processing_state" @change="getStatementsIndex(1)" style="width:150px" size="mini" clearable
              placeholder="审核状态">
              <el-option v-for="(item, index) in processStatusList" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 其他角色状态筛选 -->
          <div v-else class="selectItem">
            <label>审核状态：</label>
            <el-select v-model="verify_status" @change="getStatementsIndex(1)" style="width:150px" size="mini" clearable
              placeholder="审核状态">
              <el-option v-for="(item, index) in statusList" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </template>
        <div class="selectItem">
          <label>签约公司</label>
          <el-select v-model="company" @change="getStatementsIndex(1)" style="width:150px" size="mini" clearable
            placeholder="签约公司">
            <el-option v-for="(item, index) in customerList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>
        </div>
        <div class="selectItem">
          <label>申请日期：</label>
          <el-date-picker @change="getStatementsIndex(1)" v-model="timeMonth" style="width:240px" type="daterange"
            size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="selectItem">
          <label>甲方名称：</label>
          <el-input placeholder="请输入甲方名称" v-model.trim="customer_name" clearable
            @keydown.enter.native="customer_name ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="customer_name ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <div class="selectItem">
          <label>盖章序列号：</label>
          <el-input placeholder="请输入盖章序列号" v-model.trim="statements_seal_id" clearable
            @keydown.enter.native="statements_seal_id ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="statements_seal_id ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <div class="selectItem">
          <label>结算单序列号：</label>
          <el-input placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable
            @keydown.enter.native="statements_id ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="statements_id ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <div class="selectItem">
          <label>申请人：</label>
          <el-input placeholder="请输入申请人" v-model.trim="applicant" clearable
            @keydown.enter.native="applicant ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="applicant ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{ background: '#f5f7fa' }" :data="accountList"
          height="calc(100vh - 288px)" border>
          <el-table-column prop="statements_seal_id" label="盖章序列号" align='center' width="84" />
          <el-table-column prop="statements_id" label="结算单序列号" align='center' width="94" />
          <el-table-column prop="order_amount" label="订单金额" align='center' width="90" />
          <el-table-column prop="customer_name" label="甲方名称" align='center' min-width="100" />
          <el-table-column prop="company" label="签约公司" align='center' min-width="100" />
          <el-table-column prop="applicant" align='center' label="申请人" width="80" />
          <el-table-column prop="applicant_time" align='center' label="申请提交时间" width="93" />
          <el-table-column prop="type" align='center' label="申请类型" width="145">
            <template slot-scope="{ row }">
              <span v-if="row.type == 1">含本公司结算单盖章</span>
              <span v-else-if="row.type == 2">仅客户公司结算单盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="verify_note" align='center' label="审核状态" width="100">
            <template slot-scope="{ row }">
              <span :style="{color: getVerifyNoteColor(row.verify_status)}">{{ row.verify_note }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_status" align='center' label="盖章状态" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.seal_status == 1" style="color:#00BB5D">已盖章</span>
              <span v-else-if="row.seal_status == 0">未盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_date" align='center' label="盖章日期" width="93">
            <template slot-scope="{ row }">
              <span v-if="row.seal_date">{{ row.seal_date }}</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="file_status" align='center' label="归档状态" width="93">
            <template slot-scope="{ row }">
              <span v-if="row.file_status == 1" style="color:#00BB5D">已归档</span>
              <span v-else-if="row.file_status == 0">未归档</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_date" align='center' label="归档日期" width="93">
            <template slot-scope="{ row }">
              <span v-if="row.file_date">{{ row.file_date }}</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="enable" align='center' label="数据是否有效" width="93">
            <template slot-scope="{ row }">
              <span v-if="row.enable == 1" style="color:#00BB5D">有效</span>
              <span v-else style="color:#d51313">已作废</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作" fixed="right" width="90">
            <template slot-scope="scope">
              <button class="detailButton" @click="onClickDetailBtn(scope.row)">申请详情</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size"
            @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVerifyNoteColor } from '@/assets/js/tools.js'

export default {
  data () {
    const currentRoleId = JSON.parse(this.$cookie.getCookie('userInfo') || '{}').role_id || 0
    const isHumanDept = currentRoleId == 20 // 当前角色是否为人力部门账号
    return {
      isHumanDept,
      detailFlag: false,
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 5,
      accountList: [],
      verify_status: '',
      statusList: [
        { value: 1, label: '待商务(蒋淑平)审核' },
        { value: 2, label: '待商务(张新凯)审核' },
        { value: 3, label: '商务(蒋淑平)审核不通过' },
        { value: 4, label: '待财务审核' },
        { value: 5, label: '商务(张新凯)审核不通过' },
        { value: 6, label: '待人力审核' },
        { value: 7, label: '财务审核驳回' },
        { value: 8, label: '人力审核通过 最终审核通过' },
        { value: 9, label: '人力审核不通过' },
      ],
      processing_state: 1,
      processStatusList: [
        { value: 1, label: '待审核' },
        { value: 2, label: '审核通过' },
        { value: 3, label: '审核不通过' },
      ],
      timeMonth: [],
      customer_name: '',
      userInfo: {},
      customerList: [],
      company: '',
      statements_seal_id: '',
      statements_id: '',
      applicant: '',
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.$route.query.type) {
      this.tab = this.$route.query.type
    }
    this.getCompany()
    this.getStatementsIndex(1)
  },
  methods: {
    getVerifyNoteColor,
    getCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
    getStatementsIndex (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_verifyList, {
        params: {
          verify_status: this.isHumanDept ? 0 : (this.verify_status || 0), // 人力角色传0
          processing_state: this.isHumanDept ? (this.processing_state || 0) : 0, // 非人力角色 传0
          statements_seal_id: this.statements_seal_id,
          statements_id: this.statements_id,
          applicant: this.applicant,
          statements_type: this.tab,
          page: page,
          page_size: this.page_size,
          applicant_date_st: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[0] : '',
          applicant_date_ed: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[1] : '',
          customer_name: this.customer_name,
          company: this.company,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange (val) {
      this.getStatementsIndex(val)
    },
    onClickDetailBtn(row) {
      const routeData = this.$router.resolve({
        path: `/statementSealDetail/${this.tab}?seal_id=${row.statements_seal_id}&id=${row.statements_id}&enable_apply=${row.enable_apply ? row.enable_apply : ''}&sealType=${row.type}&action=3`,
      })
      this.$winopen(routeData.href)
    },
  },
  watch: {
    tab () {
      this.getStatementsIndex(1)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../statementApply.scss";

.flex {
  display: flex;
  flex-wrap: wrap;
}

.selectItem {
  margin-bottom: 5px;
  margin-right: 20px;
}

.topTab {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.myStatementApply {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/examine/statementSealExamine.vue